export const PAGE_TITLES: { [key: string]: string } = {
  'home': 'Reporting Home',
  'performance': 'Campaign Performance',
  'conversions': 'Post Conversions',
  'path-to-purchase': 'Path to Purchase',
  'spike-lift': 'Spike Lift',
  'beta': 'Beta',
  'cpa-internal': 'CPA Performance',
  'internal-performance': 'Campaign Performance (Internal)',
  'internal-path-to-purchase': 'Path to Purchase (Internal)',
  'internal-spike-lift': 'Spike Lift (Internal)',
  'internal-conversions': 'Post Conversions (Internal)',
  'incrementality': 'Always-on Incrementality',
  'internal-incrementality': 'Always-on Incrementality (Internal)',
};

export const DASHBOARD_NAMES: { [key: string]: string } = {
  CAMPAIGN_PERFORMANCE: 'CAMPAIGN_PERFORMANCE',
  POST_CONVERSIONS: 'SEQUENTIAL_EVENTS',
  PATH_TO_PURCHASE: 'PATH_TO_PURCHASE',
  SPIKE_LIFT: 'SPIKE_LIFT',
  CAMPAIGN_DELIVERY: 'CAMPAIGN_DELIVERY',
  INVENTORY_GEO: 'INVENTORY_GEO',
  INVENTORY_GEO_GAMING: 'INVENTORY_GEO_GAMING',
  NBCU_CAMPAIGN_DELIVERY: 'NBCU_CAMPAIGN_DELIVERY',
  NBCU_CAMPAIGN_PERFORMANCE: 'NBCU_CAMPAIGN_PERFORMANCE',
  CPA_INTERNAL: 'CPA_INTERNAL',
  CPA_EXTERNAL: 'CPA_EXTERNAL',
  CPA_INTERNAL_NBCU: 'CPA_INTERNAL_NBCU',
  CPA_EXTERNAL_NBCU: 'CPA_EXTERNAL_NBCU',
  NBCU_INCREMENTALITY: 'NBCU_INCREMENTALITY',
  INCREMENTALITY: 'INCREMENTALITY',
  SEQUENTIAL_EVENTS: 'SEQUENTIAL_EVENTS',
  BETA: 'INTERNAL_EXPERIMENTAL',
  INCREMENTALITY_ADGROUP: 'INCREMENTALITY_ADGROUP',
  INCREMENTALITY_CAMPAIGN: 'INCREMENTALITY_CAMPAIGN',
  INCREMENTALITY_SUM: 'INCREMENTALITY_SUM',
  P2P_FREQUENCY: 'P2P_FREQUENCY',
  P2P_ORDER_LIST: 'P2P_ORDER_LIST',
  P2P_CUSTOMER_JOURNEY: 'P2P_CUSTOMER_JOURNEY',
};

export const LOOKER_CHARTS: {
  [key: string]: {
    id: string,
    title: string,
    dashboardName: string
  }
} = {
  CAMPAIGN_PERFORMANCE: {
    id: 'performance',
    title: 'Performance',
    dashboardName: DASHBOARD_NAMES.CAMPAIGN_PERFORMANCE,
  },
  POST_CONVERSIONS: {
    id: 'conversions',
    title: 'Post Conversions',
    dashboardName: DASHBOARD_NAMES.POST_CONVERSIONS,
  },
  PATH_TO_PURCHASE: {
    id: 'path-to-purchase',
    title: 'Path to Purchase',
    dashboardName: DASHBOARD_NAMES.PATH_TO_PURCHASE,
  },
  SPIKE_LIFT: {
    id: 'spike-lift',
    title: 'Spike Lift',
    dashboardName: DASHBOARD_NAMES.SPIKE_LIFT,
  },
  NBCU_CAMPAIGN_DELIVERY: {
    id: 'delivery',
    title: 'NBCU Campaign Delivery',
    dashboardName: DASHBOARD_NAMES.NBCU_CAMPAIGN_DELIVERY,
  },
  CAMPAIGN_DELIVERY: {
    id: 'delivery',
    title: 'Delivery',
    dashboardName: DASHBOARD_NAMES.CAMPAIGN_DELIVERY,
  },
  INVENTORY_GEO: {
    id: 'inventory',
    title: 'Inventory & Geo',
    dashboardName: DASHBOARD_NAMES.INVENTORY_GEO,
  },
  INCREMENTALITY: {
    id: 'incrementality',
    title: 'Incrementality',
    dashboardName: DASHBOARD_NAMES.INCREMENTALITY,
  },
  SEQUENTIAL_EVENTS: {
    id: 'sequential-events',
    title: 'Sequential Events',
    dashboardName: DASHBOARD_NAMES.SEQUENTIAL_EVENTS,
  },
  BETA: {
    id: 'beta',
    title: 'Beta',
    dashboardName: DASHBOARD_NAMES.BETA,
  },
  CPA_INTERNAL: {
    id: 'cpa-internal',
    title: 'CPA Report',
    dashboardName: DASHBOARD_NAMES.CPA_INTERNAL,
  },
  INCREMENTALITY_ADGROUP: {
    id: 'incrementality-adgroup',
    title: 'Ad Group Details',
    dashboardName: DASHBOARD_NAMES.INCREMENTALITY_ADGROUP,
  },
  INCREMENTALITY_CAMPAIGN: {
    id: 'incrementality-campaign',
    title: 'Campaign Details',
    dashboardName: DASHBOARD_NAMES.INCREMENTALITY_CAMPAIGN,
  },
  INCREMENTALITY_SUM: {
    id: 'incrementality-sum',
    title: 'Account Snapshot',
    dashboardName: DASHBOARD_NAMES.INCREMENTALITY_SUM,
  },
  P2P_FREQUENCY: {
    id: 'p2p-frequency',
    title: 'Frequency & Time',
    dashboardName: DASHBOARD_NAMES.P2P_FREQUENCY,
  },
  P2P_ORDER_LIST: {
    id: 'p2p-order-list',
    title: 'Order List',
    dashboardName: DASHBOARD_NAMES.P2P_ORDER_LIST,
  },
  P2P_CUSTOMER_JOURNEY: {
    id: 'p2p-customer-journey',
    title: 'Customer Journey',
    dashboardName: DASHBOARD_NAMES.P2P_CUSTOMER_JOURNEY,
  },
}

export const P2P_DATA_MAP = {
  "links": [
    {
      "source": 0,
      "target": 1,
      "value": null
    },
    {
      "source": 0,
      "target": 2,
      "value": null
    },
    {
      "source": 0,
      "target": 3,
      "value": null
    },
    {
      "source": 0,
      "target": 4,
      "value": null
    },
    {
      "source": 1,
      "target": 5,
      "value": null
    },
    {
      "source": 2,
      "target": 6,
      "value": null
    },
    {
      "source": 3,
      "target": 7,
      "value": null
    },
    {
      "source": 4,
      "target": 8,
      "value": null
    },
    {
      "source": 5,
      "target": 9,
      "value": null
    },
    {
      "source": 6,
      "target": 9,
      "value": null
    },
    {
      "source": 7,
      "target": 9,
      "value": null
    },
    {
      "source": 8,
      "target": 9,
      "value": null
    }
  ],
  "nodes": [
    {
      "color": "#0fbf84",
      "name": "Impressions"
    },
    {
      "color": "#f27799",
      "name": "Direct/Organic"
    },
    {
      "color": "#5744b2",
      "name": "Social"
    },
    {
      "color": "#ffb837",
      "name": "Search"
    },
    {
      "color": "#727383",
      "name": "Other"
    },
    {
      "color": "#f27799",
      "name": "Direct/Organic Outcome"
    },
    {
      "color": "#5744b2",
      "name": "Social Outcome"
    },
    {
      "color": "#ffb837",
      "name": "Search Outcome"
    },
    {
      "color": "#727383",
      "name": "Other Outcome"
    },
    {
      "color": "#009061",
      "name": "Conversion"
    }
  ]
}

export const PRIMARY_OUTCOMES: { [key: string]: string } = {
  IMPRESSIONS: 'Impressions',
  WEB_SITE_VISITS: 'Website Visits',
  PURCHASES: 'Purchases',
  APP_INSTALLS: 'App Installs',
  IN_APP_PURCHASES: 'In-App Purchases',
}

export const TOOLTIP_LABELS: { [key: string]: string } = {
  outcomes: 'Outcomes',
  reach: 'Reach',
  roas: 'ROAS',
  revenue: 'Revenue',
  spend: 'Spend'
}
